import React, { useState } from "react";
import styles from "./Answers.module.scss";

import CloseButton from "../Static assets/Crosses/Cross-01.png";

function Answers(props) {
  const setSelected = props.setSelected;
  const selected = props.selected;

  function setMessage(msg) {}
  setMessage(selected.message);
  console.log(selected.image);
  return (
    <div className={styles.queryBox}>
      <img
        className={styles.close}
        src={CloseButton}
        onClick={(event) => {
          setSelected(null);
        }}
      />
      <h1>What Happened Here?</h1>
      <div className={styles.answers}>
        <p>Points: {selected.points}</p>
        {selected.message && (
          <>
            <b>Moderator Note:</b>
            <p>
              <i>{selected.message}</i>
            </p>
            <br />
          </>
        )}
        <b className={styles.questionDisplay}>
          This post was made by one of the {selected.folk} folk.
        </b>
        <p>They identified themselves as a {selected.nonhumantype}</p>
        <b className={styles.questionDisplay}>
          What kind of incident happened to you?
        </b>
        {selected.url ===
          "https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/circle-01.svg" && (
          <p>Crime</p>
        )}
        {selected.url ===
          "https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/diamond-01.svg" && (
          <p>Food</p>
        )}
        {selected.url ===
          "https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/star-01.svg" && (
          <p>Space</p>
        )}
        {selected.url ===
          "https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/triangle-01.svg" && (
          <p>Health</p>
        )}
        {selected.url ===
          "https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/hexagon-01.svg" && (
          <p>Pollution</p>
        )}
        {selected.url ===
          "https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/square-01.svg" && (
          <p>Behavior</p>
        )}
        <b className={styles.questionDisplay}>Please describe the incident:</b>
        <p> {selected.allegation}</p>
        {selected.link != "" &&
          selected.link != "video, image, or article URL" && (
            <>
              <b className={styles.questionDisplay}>Supporting Evidence:</b>
              <p>
                Supporting evidence may be images, articles, sound or video
                files, which will open in a new window when clicked.
              </p>
              <ul className={styles.linkDisplay}>
                <a href={selected.link} target="_blank">
                  Evidence 1
                </a>
                <br />
                {selected.link2 != "" &&
                  selected.link2 != "video, image, or article URL" && (
                    <a
                      className={styles.linkDisplay}
                      href={selected.link2}
                      target="_blank"
                    >
                      Evidence 2
                    </a>
                  )}
                <br />
                {selected.link3 != "" &&
                  selected.link3 != "video, image, or article URL" && (
                    <a
                      className={styles.linkDisplay}
                      href={selected.link3}
                      target="_blank"
                    >
                      Evidence 3
                    </a>
                  )}
                <br />
                <br />
              </ul>
            </>
          )}
        <b className={styles.questionDisplay}>Why is this an issue:</b>
        <p>
          <i>Explaining the impact and consequences...</i>
        </p>
        {selected.affected !== "" && selected.affected !== undefined && (
          <>
            <p>Other beings this problem impacts, are: {selected.affected}</p>
          </>
        )}
        {selected.problem !== "" && selected.problem !== undefined && (
          <p>
            It's important that this problem is solved, because:{" "}
            {selected.problem}
          </p>
        )}
        {selected.better !== "" && selected.better !== undefined && (
          <p>
            The neighborhood will be made better, because: {selected.better}
          </p>
        )}
        <p>{selected.feelings}</p>
        <b className={styles.questionDisplay}>What could the solution be?</b>
        <p>{selected.solution}</p>
      </div>
    </div>
  );
}

export default Answers;
